import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconTarget1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"target-1, zoom, crosshair"} maskId="square-filled-radius-0-stroke-1-IconTarget1"><path fillRule="evenodd" clipRule="evenodd" d="M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM12.5 6V10.5H11.5V6H12.5ZM13.5 11.5V12.5H18V11.5H13.5ZM12.5 13.5V18H11.5V13.5H12.5ZM6 11.5V12.5H10.5V11.5H6Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconTarget1;
